import { useTranslation } from '@lyearn/i18n';
import { Box, LinkButton, useSnackbar } from '@lyearn/ui';
import { EditorMode } from '@/components/ContentEditor/types';
import useNavigation from '@/hooks/useNavigation';
import AssignmentCreatorModal from '@/modules/corporate/modules/assignment/modals/AssignmentCreatorModal';
import AssignmentRestrictionHandler from '@/modules/corporate/modules/assignment/modals/AssignmentCreatorModal/AssignmentRestrictionHandler';
import routes from '@/pages/corporate/routes';

import { DialogProps } from '../../types';

const Assign = (props: DialogProps) => {
  const { onClose, content } = props;
  const { showSnackbar } = useSnackbar();
  const { t } = useTranslation(['AssignmentCreator']);
  const navigation = useNavigation();

  const onSuccess = (assignmentId: string) => {
    showSnackbar({
      message: t('AssignmentCreator:AssignContentSuccess'),
      action: (
        <Box className="flex-shrink-0">
          <LinkButton
            className="py-2 px-4"
            color={'inverse'}
            onClick={() => {
              navigation.push(routes.AssignmentDetails(assignmentId));
            }}>
            {t('Common:Actions.View')}
          </LinkButton>
        </Box>
      ),
    });
    onClose();
  };

  return (
    <AssignmentRestrictionHandler
      assignmentRestriction={content.assignmentRestriction}
      contentId={content.id}
      onClose={onClose}>
      <AssignmentCreatorModal
        isInModal
        initialContents={{
          contentIds: [content.id],
        }}
        mode={EditorMode.Edit}
        onBack={onClose}
        onSuccess={onSuccess}
      />
    </AssignmentRestrictionHandler>
  );
};

export default Assign;
